import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { Transform, Type } from "class-transformer";
import { CertificationDto } from "@/core/features/certifications/certification.dto";
import { toEuros } from "@/utils/numberUtils";
import { InvoiceDto } from "@/core/features/invoice/invoice.dto";

export class CertificationHasInvoiceDto extends BaseEntityDto {
  certificationId: string;

  invoiceId: string;

  @Transform(({ value }) => toEuros(value))
  allocatedAmount: number;

  @Type(() => CertificationDto)
  certification?: CertificationDto;

  @Type(() => InvoiceDto)
  invoice?: InvoiceDto;
}
